import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";

/** Single service card on Booking Wizard step 1. */
export default function ServiceCard({ svc, isSelected, onToggle }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <Card
      data-testid={`booking-service-card-${svc.id}`}
      className={`rounded-xl transition-all duration-150 border-2 shadow-sm cursor-pointer ${
        isSelected ? 'border-primary bg-primary/5 shadow-md' : 'border-border hover:border-primary/30 hover:shadow-md'
      }`}
      onClick={onToggle}
    >
      <div className="p-4 flex items-center justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-sm" style={{ fontFamily: 'Playfair Display' }}>{svc.name}</h4>
          {svc.description && (
            <p className={`text-xs text-muted-foreground mt-0.5 ${expanded ? '' : 'line-clamp-1'}`}>{svc.description}</p>
          )}
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <div className="text-right">
            <span className="text-sm font-semibold text-primary">£{svc.price.toFixed(2)}</span>
            <p className="text-[10px] text-muted-foreground">{svc.duration_minutes} min</p>
          </div>
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors shrink-0 ${
            isSelected ? 'bg-primary border-primary' : 'border-muted-foreground/30'
          }`}>
            {isSelected && <Check size={12} className="text-white" />}
          </div>
        </div>
      </div>
      {svc.description && svc.description.length > 60 && (
        <button
          onClick={e => { e.stopPropagation(); setExpanded(!expanded); }}
          className="w-full text-[11px] text-primary font-medium pb-2 px-4 hover:underline text-left"
        >
          {expanded ? 'Show less' : 'Read full description'}
        </button>
      )}
    </Card>
  );
}
